import React from "react";
import { makeStyles, Theme, createStyles, Typography } from "@material-ui/core";
import { ElectronAccessor, isValidUrl } from "../../helpers";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    typographyUrl: {
      fontSize: "0.875rem",
      color: theme.palette.primary.dark,
    },
  })
);

/** アンカーリンクコンポーネント */
export function ActionLink(props: { url: string }) {
  const classes = useStyles();

  const { url } = props;

  function handleClick(event: React.MouseEvent<HTMLAnchorElement>) {
    event.preventDefault();
    // ElectronAccessor.openExternal(url);
  }

  //--------------------
  // コンポーネント
  return isValidUrl(url) ? (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a href="#" onClick={handleClick}>
      <Typography component="span" className={classes.typographyUrl}>
        {url}
      </Typography>
    </a>
  ) : (
    <Typography component="span" className={classes.typographyUrl}>
      {url}
    </Typography>
  );
}
